import type SweetAlert from "sweetalert2";

// sweetalert2 is loaded on the first alert instead of being part of the entry bundle
export const fireAlert = (...args: Parameters<typeof SweetAlert.fire>) => import("sweetalert2").then(({default: Swal}) => Swal.fire(...args));
